<template>
  <div class="posters">
    <!-- 分享海报 -->
    <PosterModal
      v-model="showPosterModal"
      :pageData="pageData"
      :qrCode="qrCode"
      :copyLinkUrl="copyLinkUrl"
    ></PosterModal>
  </div>
</template>
<script>
import PosterModal from 'component/platform/homepage/common/posterModal.vue' // 海报弹窗
import { fetchQrcode } from 'api/platform/homepage.js'
import { imgZip } from 'app/web/filters/ossImg.js'
import wechatShareMixin from 'app/frontend-lib/mixins/wechatShare.js' // APP自带分享需要引入
import expertXltMixin from 'app/web/mixins/xlt/expertXltMixin.js'
import { getEnvHost } from 'app/frontend-lib/tools/getPlatform.js'
import { inMiniProgramWebview } from 'utils/tool.js'

export default {
  props: {},
  mixins: [wechatShareMixin, expertXltMixin],
  components: {
    PosterModal
  },
  data() {
    return {
      showPosterModal: false,
      qrCode: ''
    }
  },
  computed: {
    // 当前url访问的是否咨询师
    isConsultTeacher() {
      return this.$store.getters['homepage/isConsultTeacher']
    },
    // 获取页面用户信息
    basicInfo() {
      return this.$store.state.homepage.basicInfo || {}
    },
    // 获取页面用户信息
    serviceInfo() {
      return this.$store.state.homepage.serviceInfo || {}
    },
    qingsuServiceInfo() {
      return this.$store.state.homepage.qingsuService.info || {}
    },
    pageData() {
      return {
        ...this.basicInfo,
        ...(this.serviceInfo[0] || {}),
        qingsuServiceInfo: this.qingsuServiceInfo
      }
    },
    authorUserId() {
      return this.$route.params.userId
    },
    copyLinkUrl() {
      let site = ''
      if (!this.$isServer) {
        site = `https://${location.host}/homepage/${this.authorUserId}`
      }
      return site
    },
    shareConfig() {
      const { isYixinliApp, isZiXunApp, isZiXunShiApp } = this.$platform

      // app端分享海报
      if (isYixinliApp || isZiXunApp || isZiXunShiApp) {
        return {}
      }

      let title = this.isConsultTeacher
        ? `${this.pageData.nickname}-壹心理认证心理咨询师`
        : `${this.pageData.nickname}`

      const obj = {
        link: this.copyLinkUrl,
        title: title,
        desc:
          this.pageData.honor || `点击关注我，有时治愈，常常帮助，总是安慰。`,
        imgUrl: this.pageData.avatar,
        isHideSendToChat: 1
        // success: () => teacherShare({ teacher_id: this.teacherId })
      }
      console.info('homepage shareconfig:', obj)
      return obj
    }
  },
  created() {},
  mounted() {
    // 小程序分享
    if (inMiniProgramWebview()) {
      this.setMiniProgram()
    }
  },
  methods: {
    openSharePosterModal() {
      if (this.qrCode) {
        this.showPosterModal = true
        return
      }
      const loading = this.$loading()
      this.fetchQrcode()
        .then(() => {
          loading.close()
          this.showPosterModal = true
        })
        .catch(e => {
          console.log(e)
          loading.close()
          this.$toast({
            text: '生成海报失败'
          })
        })
    },
    _genQrcodeUrl() {
      // 扫码打开心乐土小程序
      if (this.mixinShowStudioInfo) {
        const HOST = getEnvHost('https://m.xinli001.com')
        const h5Page = encodeURIComponent(
          `${this.copyLinkUrl}?mark=poster&channel_flag=fxkp&isXltMp=1&node=1`
        )
        const mpPage = `${HOST}/xlt-mini-program-qr-code?v=1&to_path=${h5Page}`
        return encodeURIComponent(mpPage)
      }
      // 壹心理
      return `${this.copyLinkUrl}?mark=poster&channel_flag=fxkp`
    },
    fetchQrcode() {
      return fetchQrcode({
        url: this._genQrcodeUrl()
      })
        .then(res => {
          const { code, data } = res
          if (code === 0) {
            this.qrCode = imgZip(data.qrCode, 200, 200)
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>
<style lang="scss" scoped></style>
